module.exports = __webpack_public_path__ + "static/img/5.857c695.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/5.png
// module id = rmKL
// module chunks = 0